<ng-container
  *ngIf="stepChange.observers.length"
>
<button (click)="stepChange.emit(1)">Step 1</button>
<button (click)="stepChange.emit(2)">Step 2</button>
<button (click)="stepChange.emit(3)">Step 3</button>
</ng-container>

<button
  *ngIf="customerInfoChange.observers.length"
  (click)="fillCustomerInfo()"
>Fill Customer Info</button>

<button
  *ngIf="shippingAddressChange.observers.length"
  (click)="fillShippingAddress()"
>Fill Separate Shipping Address</button>

<ng-container
  *ngIf="paymentDataChange.observers.length"
>
<br>
Card -
<button
  (click)="fillPaymentCard(EFormPaymentTestPMToken.success)"
>(succeeded)</button>
<button
  (click)="fillPaymentCard(EFormPaymentTestPMToken.authReq)"
>(auth)</button>
<button
  (click)="fillPaymentCard(EFormPaymentTestPMToken.declined)"
>(declined)</button>
<br>
Konbini -
<button
  (click)="fillPaymentKonbini(EFormPaymentTestKonbiniNumber.succeededIn3Minutes)"
>(succeeded in 3 min)</button>
<button
  (click)="fillPaymentKonbini(EFormPaymentTestKonbiniNumber.succeededImmediately)"
>(succeeded immediately)</button>
<button
  (click)="fillPaymentKonbini(EFormPaymentTestKonbiniNumber.expiresImmediately)"
>(expires immediately)</button>
<button
  (click)="fillPaymentKonbini(EFormPaymentTestKonbiniNumber.expiresIn3Minutes)"
>(expires in 3 min)</button>
<button
  (click)="fillPaymentKonbini(EFormPaymentTestKonbiniNumber.neverSucceeds)"
>(never succeeds)</button>
<button
  (click)="fillPaymentKonbini(EFormPaymentTestKonbiniNumber.numberError1)"
>(number error 1)</button>
<button
  (click)="fillPaymentKonbini(EFormPaymentTestKonbiniNumber.numberError2)"
>(number error 2)</button>
</ng-container>
